var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35px",
    height: "35px",
    viewBox: "0 0 35 35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "avataar/default") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.974991,12.1176 C13.852605,12.1176 16.1161911,14.4171159 16.1161911,17.2588 C16.1161911,17.6681535 15.7843445,18 15.3749911,18 C14.9656376,18 14.6337911,17.6681535 14.6337911,17.2588 C14.6337911,15.2960672 13.1305157,13.7056164 11.1722912,13.605049 L10.974991,13.6 L5.87499104,13.6 C3.84683382,13.6 2.21619103,15.205164 2.21619103,17.2588 C2.21619103,17.6681535 1.88434448,18 1.47499103,18 C1.06563757,18 0.733791026,17.6681535 0.733791026,17.2588 C0.733791026,14.454971 2.91689492,12.234085 5.65749895,12.1220368 L5.87499104,12.1176 L10.974991,12.1176 Z M11.8053501,1.74764278 L11.9890146,1.91264994 L11.998991,1.92279992 C13.9422377,3.8653864 13.9992058,6.92492316 12.1613159,8.8345761 L11.9890146,9.00494996 C9.96002425,10.9145879 6.7906705,10.9510173 4.92884104,8.97282348 C3.01920308,6.94383312 2.98277373,3.77447939 4.96096752,1.91264994 C6.88948874,0.0975711424 9.8163249,0.0425687545 11.8053501,1.74764278 Z M5.98901457,3.00494993 C4.63543577,4.27890645 4.66096081,6.49958493 6.02114104,7.94477644 C7.29509755,9.29835524 9.51577605,9.2728302 10.9609675,7.91264997 C12.2994756,6.65287765 12.3472795,4.55041312 11.089758,3.1426152 L10.953991,2.99979992 L10.8070083,2.86772519 C9.39715906,1.67844407 7.34982662,1.72418565 5.98901457,3.00494993 Z",
    id: "AVATAARS-path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "AVATAARS",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AVATAARS-ICONS-backup",
    transform: "translate(-100.000000, -168.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AVATAARS-avataar/default",
    transform: "translate(100.000000, 168.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "AVATAARS-Rectangle",
    fill: "#DFE1EE",
    x: 0,
    y: 0,
    width: 35,
    height: 35,
    rx: 8
  }), /*#__PURE__*/React.createElement("g", {
    id: "AVATAARS-postIcons/outlines/ic_user",
    transform: "translate(5.500000, 5.500000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "AVATAARS-Path",
    points: "0 0 24.0000001 0 24.0000001 24.0000001 0 24.0000001"
  }), /*#__PURE__*/React.createElement("g", {
    id: "AVATAARS-colours/neutral/N100",
    transform: "translate(3.525009, 2.741200)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "AVATAARS-mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#AVATAARS-path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "AVATAARS-Mask",
    fill: "#323232",
    fillRule: "nonzero",
    xlinkHref: "#AVATAARS-path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "AVATAARS-Group",
    mask: "url(#AVATAARS-mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-48.000000, -42.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "AVATAARS-colours/neutral/N100",
    fill: "#7A869A",
    x: 0,
    y: 0,
    width: 120,
    height: 120
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.a5b8afc5e6349d27bb060a954bf2f064.svg";
export { ForwardRef as ReactComponent };